module.exports = __webpack_public_path__ + "img/gmb.50fe2799.svg";